
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { ChannelModel } from '@/models/forumAPI/ChannelModel';
import { DiscussionModel } from '../../models/forumAPI/DiscussionModel';
import { getPaddedDisplayNumber } from '@/helpers/string';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    channel: {
      type: Object as Vue.PropType<ChannelModel>,
      required: true,
    },
  },
  computed: {
    title(): string {
      return this.channel.name;
    },
    discussionCount(): number {
      return this.channel.discussionCount;
    },
    paddedDiscussionCount(): string {
      return getPaddedDisplayNumber(this.discussionCount);
    },
    commentsCount(): number {
      if (!this.channel.discussions || this.channel.discussions.length === 0) {
        return 0;
      }
      const total = this.channel.discussions.reduce(
        (acc: number, discussion: DiscussionModel) => acc + discussion.comments.length,
        0,
      );
      return total;
    },
    paddedCommentsCount(): string {
      return getPaddedDisplayNumber(this.commentsCount);
    },
    participantCount(): number {
      return this.channel.participantCount;
    },
    paddedParticipantCount(): string {
      return getPaddedDisplayNumber(this.participantCount);
    },
  },
});
